import React, { memo, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Avatar, Dropdown, Layout } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { IoMdHome } from "react-icons/io";
import { HEADER_LOGO, PROFILE } from "@src/helpers/imagesConstants";
import {
  AppDispatch,
  getMyOrganization,
  getMyOrganizationClear,
  getMyOrganizationRequest,
  getUserList,
  loginClear,
} from "@src/redux";
import { useDispatch, useSelector } from "react-redux";
import { FaFilter } from "react-icons/fa";
import { startCase } from "lodash";
import { HiMenuAlt1 } from "react-icons/hi";
import { retrieveItem, storeItem } from "@src/helpers/functions";
import { useMediaQuery } from "react-responsive";
import { findPath } from "@src/helpers/constants";
import myRoutes from "@src/routes/MyRoutes";
import ExportNotificationBell from "@src/views/components/common/ExportNotificationBell";
import { useCheckPageAccess } from "@src/hooks/index";

const { Header } = Layout;

interface HeaderBarProps {
  title: string;
  showTitle: boolean;
  setTitle: (title: string) => void;
  toggle: () => void;
}

const HeaderBar: React.FC<HeaderBarProps> = memo((props: HeaderBarProps) => {
  const { setTitle, toggle } = props;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { result: userResult } = useSelector(getUserList);
  const user = retrieveItem("user");
  const { pathname } = useLocation();
  const { id } = useParams();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { result: myOrgResult } = useSelector(getMyOrganization);
  let homePage: string = retrieveItem("homePage");

  useEffect(() => {
    let parts = document.title.split("|");
    let place = parts[0].trim();
    setTitle(place);
  }, [setTitle]);

  const hasReportAccess = useCheckPageAccess("Report");

  const items = [
    {
      label: (
        <b>
          {"Hai"}
          {"  "}
          {startCase(
            userResult?.items?.[0]?.systemUser?.name ||
              userResult?.items?.[0]?.systemUser?.username?.split("~")?.[1]
          )}
        </b>
      ),
      key: "welcome_text",
    },
    {
      label: <a href="/settings/account"> {t("my_account")}</a>,
      key: "my_account",
    },
    // Gated on the same access key MyRoute checks for /settings/report, so the
    // entry never points at a page that would redirect to "not allowed".
    ...(hasReportAccess
      ? [
          {
            label: t("report"),
            key: "report",
          },
        ]
      : []),
    {
      label: t("logout"),
      key: "logout",
    },
    {
      label: <b> {t("help")}</b>,
      key: "help",
    },
    {
      label: (
        <a href="https://www.vincense.com/contact-us/"> {t("contact_us")}</a>
      ),
      key: "contact_us",
    },
    {
      label: (
        <a href="https://www.vincense.com/privacy-policy/"> {t("privacy")}</a>
      ),
      key: "privacy",
    },
  ];

  const handleMenuClick = (e: { key: string }) => {
    if (e.key === "report") {
      setOpen(false);
      navigate("/settings/report");
      return;
    }
    if (e.key === "logout") {
      // Clear Redux states
      dispatch(getMyOrganizationClear());
      dispatch(loginClear());

      // Clear localStorage & sessionStorage
      localStorage.clear();
      sessionStorage.clear();

      // Clear all cookies
      document.cookie.split(";").forEach((cookie) => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie =
          name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      });

      // Redirect to login page
      navigate("/login");
    }

    //  else if (e.key === "contact_us") {
    //   window.open("https://www.vincense.com/contact-us/");
    // } else if (e.key === "privacy") {
    //   window.open("https://www.vincense.com/privacy-policy/");
    // } else if (e.key === "my_account") {
    //   window.open("/settings/account", "blank");
    // }
  };

  const handleOpenChange = (flag: boolean) => {
    setOpen(flag);
  };

  const homeClick = () => {
    // navigate(``);
  };
  useEffect(() => {
    if (myOrgResult?.id) {
      storeItem("my_org_result", { myOrgResult: myOrgResult });
    }
  }, [myOrgResult]);

  useEffect(() => {
    dispatch(getMyOrganizationRequest({}));
  }, []);

  return (
    <Header className="header">
      {pathname.includes("details") && !id && isMobile ? (
        <FaFilter className="reading-filter-icon" onClick={toggle} />
      ) : (
        <div className="mobile-drawer-home-icon-container">
          <HiMenuAlt1 className="mobile-drawer-icon" onClick={toggle} />
          <a
            href={`${findPath(myRoutes, homePage)}`}
            // target="_blank"
            className="icon-navigate-box"
          >
            <IoMdHome className="reading-filter-icon" />
          </a>
        </div>
      )}
      <div className="header_logo">
        <img src={HEADER_LOGO} className="vincense_logo" alt="VinCense Logo" />
      </div>
      <div className="header-actions">
        {pathname === "/home" && <ExportNotificationBell />}
        <Dropdown
          menu={{
            items,
            onClick: handleMenuClick,
          }}
          onOpenChange={handleOpenChange}
          open={open}
        >
          <div className="header-user-container">
            <Avatar
              icon={<UserOutlined />}
              src={PROFILE}
              alt="Profile"
              className="profile_logo"
            />
          </div>
        </Dropdown>
      </div>
    </Header>
  );
});

export default HeaderBar;
